import React from "react";
import SideBar from "../Components/Dashbord/Sidebar";
import Header from "../Components/Header/Header";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <>
      <SideBar />
        <div className="dashBoxMain">
          <div className="taskBodyColor min-vh-100">
            <Header />
            <Outlet />
          </div>
        </div>
    </>
  );
}

export default Layout;
